// src/pages/Administration/EmailSent.tsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChoshiiLogo from '../../ChoshiiLogo';
import StartFooter from './StartFooter';


const EmailSent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const email = (location.state as { email?: string })?.email || '';

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        background:
          'radial-gradient(circle at top, #020617 0, #000 40%, #020617 100%)',
        color: '#f9fafb',
        fontFamily:
          'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* HEADER – same style family */}
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 30,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 25px',
          background: 'rgba(2, 6, 23, 0.9)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(148,163,184,0.2)',
        }}
      >
        {/* Left: logo -> home */}
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <ChoshiiLogo
            animateSheen
            fontFamily="'Playfair Display', serif"
            style={{ width: 160 }}
            padding={0}
          />
        </div>
      </header>

      {/* MAIN – centered card */}
      <main
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '28px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 420,
            borderRadius: 24,
            border: '1px solid rgba(148,163,184,0.3)',
            background:
              'linear-gradient(145deg, rgba(15,23,42,0.98), rgba(2,6,23,0.98))',
            boxShadow: '0 25px 60px rgba(0,0,0,0.9)',
            padding: '30px 28px 32px',
            position: 'relative',
          }}
        >
          
          {/* Content */}
          <div
            style={{
              textAlign: 'center',
              marginTop: 10,
            }}
          >
            <h2
              style={{
                marginBottom: 12,
                fontSize: 22,
                letterSpacing: -0.02,
                color: '#b1b8c7',
              }}
            >
              📧 {t('emailSentTitle')}
            </h2>

            <p
              style={{
                marginTop: 10,
                fontSize: 14,
                color: '#e5e7eb',
              }}
            >
              {t('emailSentSubtitle')}{' '}
              {email && <strong>{email}</strong>}
            </p>

            <p
              style={{
                marginTop: 12,
                fontSize: 13,
                color: '#9ca3af',
              }}
            >
              {t('emailSentNote')}
            </p>

            <button
              onClick={() => navigate('/')}
              style={{
                marginTop: 24,
                padding: '10px 24px',
                backgroundColor: 'rgb(56, 6, 117)',
                color: 'white',
                border: 'none',
                borderRadius: 999,
                cursor: 'pointer',
                fontSize: 15,
                fontWeight: 600,
              }}
            >
              {t('emailSentReturnButton')}
            </button>
          </div>
        </div>
      </main>
            <StartFooter />

    </div>
  );
};

export default EmailSent;
